var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7518 30.7395C24.036 30.7395 30.7517 24.0238 30.7517 15.7396C30.7517 7.45541 24.036 0.739746 15.7518 0.739746C7.46762 0.739746 0.751953 7.45541 0.751953 15.7396C0.751953 24.0238 7.46762 30.7395 15.7518 30.7395Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9388 11.5197C24.296 11.8047 23.6045 11.9975 22.8793 12.0836C23.6197 11.64 24.1879 10.9381 24.4561 10.1004C23.7633 10.5114 22.9957 10.8095 22.1793 10.9702C21.5253 10.2737 20.5935 9.83838 19.5616 9.83838C17.5819 9.83838 15.9762 11.444 15.9762 13.4238C15.9762 13.7048 16.008 13.9783 16.0695 14.2409C13.0898 14.0914 10.4477 12.6641 8.67923 10.4943C8.37067 11.0237 8.19366 11.64 8.19366 12.297C8.19366 13.5406 8.8271 14.6385 9.78862 15.2813C9.20117 15.2629 8.64795 15.1016 8.16478 14.8324C8.16451 14.8476 8.16451 14.8628 8.16451 14.8778C8.16451 16.615 9.40091 18.064 11.0408 18.3932C10.7403 18.4755 10.4229 18.5191 10.0964 18.5191C9.86483 18.5191 9.64049 18.4969 9.42177 18.4552C9.87793 19.8793 11.2018 20.9159 12.7711 20.9451C11.5437 21.9069 9.99798 22.4799 8.31773 22.4799C8.02895 22.4799 7.74284 22.463 7.46289 22.4296C9.04876 23.4473 10.9338 24.0406 12.9585 24.0406C19.5533 24.0406 23.1598 18.5774 23.1598 13.839C23.1598 13.6837 23.1564 13.5289 23.1494 13.3754C23.8505 12.87 24.4583 12.2387 24.9388 11.5197Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.75 0.739746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.39ad0efa5f4e16ef737ee00c0dc459fc.svg";
export { ForwardRef as ReactComponent };